var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_video-circle",
    "data-name": "vuesax/bold/video-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.165,
    height: 40.165,
    viewBox: "0 0 40.165 40.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.735,0A16.735,16.735,0,1,0,33.471,16.735,16.741,16.741,0,0,0,16.735,0Zm4.452,19.63-2.142,1.238L16.9,22.107c-2.761,1.59-5.021.284-5.021-2.9V14.258c0-3.2,2.259-4.485,5.021-2.9L19.045,12.6l2.142,1.238C23.948,15.43,23.948,18.041,21.187,19.63Z",
    transform: "translate(3.347 3.347)",
    fill: "#26abe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H40.165V40.165H0Z",
    fill: "none",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircle);
export default __webpack_public_path__ + "static/media/video-circle.c517a300c6c52edfe3a8e27b669c2a4b.svg";
export { ForwardRef as ReactComponent };